import { createClient } from "@supabase/supabase-js";

// Prod bruker VITE_SUPABASE_*; Supabase Vercel-integrasjonen setter
// NEXT_PUBLIC_SUPABASE_* dynamisk per preview-branch. Vite er konfigurert
// til å eksponere begge prefiks — vi faller tilbake til NEXT_PUBLIC hvis
// VITE ikke er satt. Se vite.config.ts og VIB-431.
const env = import.meta.env as Record<string, string | undefined>;

export const SUPABASE_URL = env.VITE_SUPABASE_URL ?? env.NEXT_PUBLIC_SUPABASE_URL ?? "";
export const SUPABASE_ANON_KEY = env.VITE_SUPABASE_ANON_KEY ?? env.NEXT_PUBLIC_SUPABASE_ANON_KEY ?? "";
export const SUPABASE_FUNCTIONS_URL = SUPABASE_URL ? `${SUPABASE_URL}/functions/v1` : "";

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.warn("Missing SUPABASE_URL or SUPABASE_ANON_KEY (checked VITE_ and NEXT_PUBLIC_)");
}

export const supabase = createClient(
  SUPABASE_URL,
  SUPABASE_ANON_KEY,
  {
    auth: {
      // Bypass navigator.locks to avoid orphaned lock issues with HMR / React Strict Mode
      lock: async (_name: string, _acquireTimeout: number, fn: () => Promise<any>) => fn(),
      persistSession: true,
      autoRefreshToken: true,
    },
  },
);

// Eksponer klienten på window i dev for E2E-cleanup (tester kjører
// mot prod-DB inntil vi har isolert test-database). Aldri i prod-build.
if (import.meta.env.DEV) {
  (window as unknown as { __supabase?: typeof supabase }).__supabase = supabase;
}
